import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { ReactComponent as CloseIcon } from 'assets/icons/CloseIcon.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/Warning.svg';
import { getNotificationSelector, reset } from 'store/slices/notification-slice';
import { NOTIFICATION_TYPE } from 'types/general.types';

import styles from './AppNotification.module.scss';

export const AppNotification = () => {
  const dispatch = useDispatch();
  const { isShow, message, type } = useSelector(getNotificationSelector);

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(reset());
  };

  if (!isShow) return null;

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <WarningIcon
          className={cn({
            [styles.error]: type === NOTIFICATION_TYPE.ERROR,
            [styles.warning]: type === NOTIFICATION_TYPE.WARNING,
            [styles.success]: type === NOTIFICATION_TYPE.SUCCESS,
          })}
        />
      </div>
      <p className={styles.message}>{message}</p>
      <div className={styles.iconContainer}>
        <CloseIcon className={styles.closeIcon} onClick={handleClose} />
      </div>
    </div>
  );
};
